export const TABS = {
  ALL_STOCK: {
    key: 0,
    name: '個股資訊'
  },
  STRATEGY: {
    key: 1,
    name: '自選策略'
  },
}
